import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="395.819"
      height="516.399"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 395.819 516.399"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-775.06 -1599.1)"
      >
        <path
          strokeWidth="5"
          d="M976.5 1607.2c-.467 3.73-4.9 6.07-13.3 7-8.4.93-15.867 3.97-22.4 9.1-6.533 5.13-10.733 7.7-12.6 7.7-1.867 0-4.2-1.4-7-4.2-2.8-2.8-6.533-4.9-11.2-6.3-4.667-1.4-8.4-1.4-11.2 0-2.8 1.4-5.367 1.87-7.7 1.4-2.333-.47-6.067 1.4-11.2 5.6-5.133 4.2-8.167 8.63-9.1 13.3-.933 4.67-2.1 7.7-3.5 9.1-1.4 1.4-1.633 3.5-.7 6.3s.233 5.13-2.1 7-3.5 8.4-3.5 19.6c0 11.2 1.167 17.73 3.5 19.6 2.333 1.87 8.4 3.27 18.2 4.2 4.9.47 9.8.93 14.7 1.4l-.7 6.3-.7 6.3h1.4c.933 0 2.1-1.63 3.5-4.9.395-.92 4.889-13.63 8.836-19.78 3.05-4.75 5.762-3.26 6.067-3.97-.1.8.843 5.04-1.948 9.81-3.715 6.34-11.422 13.57-11.555 14.64-.467 3.73-1.4 6.3-2.8 7.7-1.4 1.4-1.633 3.73-.7 7s2.8 6.07 5.6 8.4 5.133 5.37 7 9.1c1.867 3.73 2.8 8.17 2.8 13.3 0 5.13-.467 8.4-1.4 9.8-.933 1.4-3.267 2.33-7 2.8-3.733.47-10.967 3.27-21.7 8.4-10.733 5.13-17.267 7.47-19.6 7-2.333-.47-3.733 0-4.2 1.4l-.7 2.1c-.7-.47-1.4-.93-2.1-1.4-.7-.47-1.4-.93-2.1-1.4l-1.4 4.2-1.4 4.2c-.7-.23-1.4-.47-2.1-.7-1.4-.47-2.567 0-3.5 1.4-.933 1.4-1.867 1.87-2.8 1.4-.933-.47-1.867 0-2.8 1.4-.933 1.4-5.133 3.97-12.6 7.7s-14.233 9.33-20.3 16.8c-6.067 7.47-11.2 15.63-15.4 24.5-4.2 8.87-7.7 19.37-10.5 31.5-2.8 12.13-4.433 26.37-4.9 42.7-.467 16.33.233 37.1 2.1 62.3 1.867 25.2 5.133 42 9.8 50.4 4.667 8.4 12.133 16.1 22.4 23.1l15.4 10.5-3.5 4.2c-2.333 2.8-3.5 5.13-3.5 7v2.8c.461 0 2.767 3.87 4.246 2.43 1.514-1.47 2.201-8.25 2.674-8.25 1.866 0-.387 6.99 1.48 9.32 1.114 1.39 5.224 6.8 12.17 2.78 3.644-2.11 2.265-20.02 4.972-19.64 1.67.23-2.189 17.01-.124 21.1 1.484 2.94 5.541 3.75 8.259.86 3.416-3.62 4.402-12.47 6.122-12.31 1.194.11-4.776 8.89-1.795 12.9 1.849 2.49 5.846 2.52 9.058 2.63 7.244.23 6.658-10.69 8.646-10.6 3.247.15-1.922 9 .688 9.96 6.97 2.56 19.744-1.42 22.004-2.78 4.667-2.8 8.867-4.2 12.6-4.2 3.733 0 13.767 1.87 30.1 5.6 16.333 3.73 28.467 7.47 36.4 11.2 7.933 3.73 16.1 5.37 24.5 4.9 8.4-.47 12.83-.23 13.3.7.47.93 4.2.23 11.2-2.1 7-2.33 11.9-5.83 14.7-10.5 2.8-4.67 12.6-6.3 29.4-4.9 16.8 1.4 29.4 1.87 37.8 1.4 8.4-.47 14.7-2.33 18.9-5.6 4.2-3.27 7.47-6.77 9.8-10.5 2.33-3.73 6.53-13.77 12.6-30.1 6.07-16.33 10.5-31.5 13.3-45.5 2.8-14 4.43-28.47 4.9-43.4.47-14.93-1.17-30.8-4.9-47.6-3.73-16.8-6.3-25.67-7.7-26.6-1.4-.93-5.37-8.87-11.9-23.8-6.53-14.93-11.2-23.8-14-26.6-2.8-2.8-7.93-4.9-15.4-6.3-7.47-1.4-13.07-3.73-16.8-7-3.73-3.27-8.17-6.07-13.3-8.4-5.13-2.33-7-9.33-5.6-21 1.4-11.67 3.27-19.13 5.6-22.4 2.33-3.27 3.03-8.63 2.1-16.1-.93-7.47-2.33-12.6-4.2-15.4-1.87-2.8-2.8-5.37-2.8-7.7s.7-3.97 2.1-4.9c.7-.47 1.4-.93 2.1-1.4-.7-.47-1.4-.93-2.1-1.4-1.4-.93-1.17-3.97.7-9.1 1.87-5.13 4.43-7.93 7.7-8.4 3.27-.47 6.3-.23 9.1.7 2.8.93 5.37 0 7.7-2.8s3.27-7.23 2.8-13.3c-.47-6.07-1.4-10.5-2.8-13.3-1.4-2.8-3.97-5.13-7.7-7s-6.3-3.97-7.7-6.3c-1.4-2.33-3.27-3.73-5.6-4.2-2.33-.47-4.43-2.33-6.3-5.6-1.87-3.27-7.7-8.63-17.5-16.1-9.8-7.47-18.2-11.43-25.2-11.9-7-.47-13.53-2.1-19.6-4.9-6.07-2.8-10.73-3.97-14-3.5-3.267.47-6.3-1.17-9.1-4.9-2.8-3.73-5.133-5.6-7-5.6s-3.267-1.17-4.2-3.5c-.933-2.33-2.1-3.5-3.5-3.5s-2.333 1.87-2.8 5.6z"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M910.985 1904.9c1.25-1.81 4.063-4.88 5.852-6.23.437-.32.22 1.07.295 1.62.116.83.078 2.73.04 3.4a76.9 76.9 0 01-.326 4.14c-.29 2.57-.727 5.12-1.091 7.69-.035.24-.673 4.43.698 2.45"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M924.527 1899.77c-1.078-.75 3.255-1.26 3.88-1.55 1.088-.5 6.846-5.27 7.321-1.83.181 1.31-2.364 4.19-2.815 5.09-2.251 4.51-2.823 9.84-4.929 14.47-.474 1.04-2.191 4.03-1.789 5.23"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M938.535 1771.2s-19.715 36.49-32.157 60.22c-8.732 16.65-17.39 40.73-28.286 61.03-12.831 23.89-27.914 45.49-37.078 66.72-11.165 25.86-10.331 50.46-9.021 54.79 4.599 15.17 19.774 27.36 19.774 27.36"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M938.515 1771.28s-15.962 59.65-26.437 94.82c-7.449 25.01-19.118 48.91-17.128 68.68 2.118 21.03 14.933 42.33 33.51 48.13 23.431 7.32 41.348 4.86 62.478-12.44 9.972-8.16 21.422-39.03 23.842-64.53 2.71-28.53-4.25-51.48-4.25-51.48"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M1033.11 1836.03s1.81 36.09 11.21 66.69c9.39 30.6 26.16 57.47 26.16 57.47s27.42 57.51 20.17 83.14c-5.88 20.79-33.54 20.79-33.54 20.79"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M827.736 2073.7s5.364-7.63 8.42-13.28c3.056-5.65.042-6.67 4.159-11.43 4.117-4.75.737-1.89 12.309-7.61 11.572-5.72 11.817-13.22 33.98-15.27 22.163-2.05 34.454.61 54.672 7.06 14.122 4.51 27.95 12.47 27.95 12.47"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M903.53 2090.99s9.461-11.41 26.011-22.53c16.55-11.13 23.717-15.49 40.188-21.97 16.472-6.47 13.708-4.26 27.575-6.2 13.866-1.94 27.896-1.55 27.896-1.55l-16.35 18.87s-11.954 2.06-15.749 4.77c-3.795 2.71-3.41 6.96.572 6.06 3.981-.89 15.357-9.65 15.357-9.65l21.79-24.09s5.56-3.12 7.76-.83 1.02 9.98 1.02 9.98-10.27 20.55-20.49 32.88c-10.23 12.32-20.289 14.64-20.289 14.64"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1040.53 2041.98c13.06-8.96 12.29 4.56 7.75 13.8-6.92 14.1-20.14 44.12-37.5 47.79"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1048.21 2058.25c5.91-3.12 7.7 6.2 6.79 9.94-2.44 10.07-7.25 22.49-13.95 30.55"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M842.163 1903.87c-3.225 9.66-7.254 33.68 7.521 36.13"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M832.523 2016.16c-9.714 1.86-22.256 3.14-30.4 9.35"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M950.042 1986.21c4.065-4.8 7.354-10.7 8.226-17.03-.9 5.93-1.566 11.33-3.336 17.18"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1071.31 1960.45c-1.15-6.35 2.78-13.3 4.65-20.5 1.66-6.44 1.54-14.14 1.28-20.27"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M914.282 1750.12s8.976-15.72 9.933-18.24c2.785-7.31 7.863-15.06 9.39-22.65 1.279-6.35 4.39-13.75 8.612-18.79 1.669-1.99 17.342-18.84 19.298-19.37"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M918.284 1692.73c.748-3.71 8.614-10.43 11.338-13.67 8.585-10.24 18.668-20.93 30.155-27.87 3.646-2.2 6.906-4.74 11.173-5.52"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M972.368 1645.28c-1.006-.78-5.247 6.46-5.734 7.83-2.394 6.76-4.012 13.45-4.54 20.55-.138 1.85-1.206 5.95.274 7.3 2.087 1.9 7.02-1.66 8.616-2.83a42.88 42.88 0 005.551-4.92c2.724-2.85 6.391-5.69 8.521-9.01 2.763-4.32 8.211-11.06 6.777-16.34"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M979.75 1649.92c-1.018 1.55-.827 4.56-1.104 6.15-.958 5.5 3.007-.07 2.12-4.54-.097-.49-.623-2.21-1.016-1.61z"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M968.447 1646.77c-6.189-1.25 5.854-10.69 8.086-11.51 10.073-3.72 9.628.1 17.451 4.58"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M976.25 1635.33c.769-3.82 12.142-6.03 15.451-4.13 5.665 3.25 5.445 12.41 2.71 17.18"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M979.541 1642.3c1.439 2.16 4.379 3.2 6.544 4.13 2.822 1.22 5.126-1.51 7.582-1.02"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M975.092 1610.2c-1.079 5.36-6.112 17.02-4.925 22.7.179.86 1.265 5.45 2.598 5.08"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M990.746 1611.96s.345 4.4.328 5.7c-.046 3.43-.55 9.5-2.75 12.32"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M989.38 1631.4c-.056-.2 9.504-9.22 10.451-11.48"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M997.567 1640.7c3.423.69 5.763-2.22 8.613-3.5 3.39-1.52 6.79-3.85 10.63-4.16 5.95-.47 12.93 1.69 17.47-4.13"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M995.452 1866.6c-.372-.35-.177-.68.164-1.04 2.863-3 6.284-6.58 9.394-9.27 5.57-4.83 16.86-16.31 19.01-23.31"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1077.83 1806.4c-1.27.09-5.61 11.72-7.04 13.68-5.89 8.04-11.14 12.62-21.75 13.37-8.97.64-18.04-1.18-27.05-1.51-2.99-.11-6-.11-8.99-.18-1.03-.03-4.32-.4-3.78-.26"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;